<template>
  <header>
    <b-navbar
      toggleable
      fixed="top"
      :type="variant"
      :class="{'navbar--opaque': navbarOpaque}"
    >
      <b-navbar-brand
        to="/"
        class="p-0 Logo"
      >
        <inline-svg
          class="Logo Logo--transition"
          :class="{'Logo--delay': !isMenuActive, 'Logo--light': isMenuActive}"
          :src="require('@/assets/poetix-logo.svg')"
        />
      </b-navbar-brand>
      <b-navbar-toggle
        target="nav-collapse"
      >
        <template #default="{ expanded }">
          <div
            v-if="expanded"
            class="burgerMenu burgerMenu--light burgerMenu--close burgerMenu--transition"
          >
            <span class="burgerMenu__bar burgerMenu__bar1" />
            <span class="burgerMenu__bar burgerMenu__bar2" />
            <span class="burgerMenu__bar burgerMenu__bar3" />
          </div>
          <div
            v-else
            class="burgerMenu burgerMenu--dark burgerMenu--transition"
            :class="{'burgerMenu--delay': !isMenuActive}"
          >
            <span class="burgerMenu__bar burgerMenu__bar1" />
            <span class="burgerMenu__bar burgerMenu__bar2" />
            <span class="burgerMenu__bar burgerMenu__bar3" />
          </div>
        </template>
      </b-navbar-toggle>
      <b-collapse
        id="nav-collapse"
        is-nav
        :class="{'navbar-collapse--delay': !isMenuActive}"
      >
        <header-menu />
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
import HeaderMenu from './blocks/HeaderMenu.vue'

export default {
  name      : 'AppHeader',
  components: { HeaderMenu },
  props     : { variant: { type: String, default: '' } },
  data () {
    return {
      isMenuActive: false, navbarOpaque: false, currentVariant: null,
    }
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'nav-collapse') this.isMenuActive = isJustShown
    })
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    updateScroll () {
      if (window.scrollY > 10)
        this.navbarOpaque = true
      else
        this.navbarOpaque = false
    },
  },
}
</script>
